import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_ADD_REQUEST_WITHIN_BRAND, ROUTE_REQUEST_WITHIN_BRAND, ROUTE_VIEW_REQUEST_WITHIN_BRAND} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const NewRequest = lazy(() =>
  import('../../../screens/NewRequest')
    .then(module => ({default: module.NewRequest})));

const AddNewRequest = lazy(() =>
  import('../../../screens/NewRequest')
    .then(module => ({default: module.AddNewRequest})));

const ViewRequestFund = lazy(() =>
  import('../../../screens/NewRequest')
    .then(module => ({default: module.ViewRequestFund})));

const NewRequestNavigation = [
  {
    path: ROUTE_REQUEST_WITHIN_BRAND,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <NewRequest />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_REQUEST_WITHIN_BRAND,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddNewRequest />
      </Suspense>
    ),
  },
  {
    path: ROUTE_VIEW_REQUEST_WITHIN_BRAND,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ViewRequestFund />
      </Suspense>
    ),
  },
];

export default NewRequestNavigation;
